import Base, { baseInit } from './base';

class LineItemTargeting extends Base {
  id = null; // Integer
  targetableElementId = null; // Integer
  value = null; // String

  constructor(data) {
    super(data);
    baseInit(this, data, true);
  }
}

export default LineItemTargeting;
